import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useCopyToClipboard } from 'react-use'

import { StorageAPI } from '@makyoapp/makyo-sdk'
import { IFilePresenter } from '@makyoapp/makyo-sdk/models/Files'
import { Clipboard16, OpenNew16, Trash16 } from '@makyoapp/makyo-icon/icon'
import { DeleteModal, MoreDropdown } from '@makyoapp/makyo-ui'

import { useStorageContext } from '@/context/StorageContext'

/**
 * @todo add loading on each (table and grid) when deleting item
 */
export function StorageMoreDropdown({ item }: { item: IFilePresenter }) {
  const { t } = useTranslation()
  const { refreshStorage, setLoadingDelete } = useStorageContext()
  const [, setCopy] = useCopyToClipboard()
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const [isDeleting, setIsDeleting] = useState(false)

  const handleDeleteStorageItem = (id: string) => {
    setLoadingDelete(true)
    StorageAPI.ReqDeleteMany({
      _Files: [item._id],
    })
      .then(async () => {
        await refreshStorage()
      })
      .finally(() => {
        setLoadingDelete(false)
      })
  }

  // Handle delete with DeleteModal
  const handleDeleteWithModal = async () => {
    setIsDeleting(true)

    try {
      // Call the original onDelete function
      await handleDeleteStorageItem(item._id)

      // Close the modal
      setIsDeleteModalOpen(false)
    } catch (error) {
      console.error('Error deleting folder:', error)
    } finally {
      setIsDeleting(false)
    }
  }

  return (
    <>
      <MoreDropdown placement='auto-end' portalMenu menuClassName='text-m-m'>
        <a className='flex-c mk-mdd-item' href={item._Link} target='_blank' rel='noopener noreferrer'>
          <OpenNew16 />
          <div className='min-w-20'>Open in New Tab</div>
        </a>
        <MoreDropdown.MenuItem
          className='cursor-pointer'
          onClick={() => {
            setCopy(item._Link)
          }}
        >
          <Clipboard16 />
          <div>
            <Trans>Copy URL</Trans>
          </div>
        </MoreDropdown.MenuItem>
        <MoreDropdown.MenuItem
          className='red'
          onClick={() => {
            setIsDeleteModalOpen(true)
          }}
        >
          <Trash16 />
          <div>
            <Trans>Delete</Trans>
          </div>
        </MoreDropdown.MenuItem>
      </MoreDropdown>
      {/* Delete Folder Confirmation Modal */}

      <DeleteModal
        show={isDeleteModalOpen}
        onHide={() => setIsDeleteModalOpen(false)}
        onSubmit={handleDeleteWithModal}
        onCancel={() => setIsDeleteModalOpen(false)}
        title={t('Delete Item')}
        withCancel={true}
        cancelLabel={t('Cancel')}
        continueLabel={t('Yes, Delete')}
        isLoading={isDeleting}
        id='delete-single-folder-modal'
      >
        <p>
          {t('Are you sure you want to delete the item? This action cannot be undone.')}

          {/*{selectedFiles.length === 1
          ? t("Are you sure you want to delete this file? This action cannot be undone.")
          : t("Are you sure you want to delete these {count} files? This action cannot be undone.", {count: selectedFiles.length})
        }*/}
        </p>
      </DeleteModal>
    </>
  )
}
